function isLocalDevHost(hostname) {
  const value = String(hostname || "").trim().toLowerCase();
  return value === "localhost" || value === "127.0.0.1" || value === "::1";
}

function normalizeApiBase(rawValue) {
  const normalized = String(rawValue || "").trim().replace(/\/+$/, "");
  if (!normalized) return "";
  // Prevent accidental double-prefixing when env is set like https://api.example.com/api
  return normalized.replace(/\/api$/i, "");
}

export function resolveApiBase() {
  const fromEnv = normalizeApiBase(process.env.REACT_APP_API_URL);
  if (fromEnv) return fromEnv;

  if (typeof window !== "undefined" && isLocalDevHost(window.location.hostname)) {
    return "http://localhost:5000";
  }

  // Production-safe default: same origin (frontend domain), useful when reverse-proxying /api.
  return "";
}
